import { atom } from "jotai";

export const iframeFocusModeAtom = atom<HTMLIFrameElement | null>(null);

// Sets up iframe communication: listens for "iframe-ready" → responds with "canvas:focus-mode"
export const iframeFocusModeSetupSetter = atom(
  null,
  (
    _,
    __,
    { iframe, onReady }: { iframe: HTMLIFrameElement; onReady: () => void },
  ) => {
    const handleMessage = (messageEvent: MessageEvent) => {
      // Validate that the iframe-ready event came from the specific iframe we're listening for
      if (
        messageEvent.data?.event === "iframe-ready" &&
        messageEvent.source === iframe.contentWindow
      ) {
        if (iframe.contentWindow) {
          const message = { type: "canvas:focus-mode" };
          iframe.contentWindow.postMessage(message, "*");
        }

        onReady();

        window.removeEventListener("message", handleMessage);
      }
    };

    window.addEventListener("message", handleMessage);
  },
);

iframeFocusModeSetupSetter.debugLabel = "iframeFocusModeSetupSetter";
